export const COLORES_PRESUPUESTO = {
  borrador:    { bg: '#f1f5f9', color: '#64748b' },
  enviado:     { bg: '#dbeafe', color: '#1e40af' },
  aceptado:    { bg: '#fef3c7', color: '#92400e' },   // aceptado = espera la aprobación interna
  aprobado:    { bg: '#dcfce7', color: '#166534' },
  rechazado:   { bg: '#fee2e2', color: '#991b1b' },
  perdido:     { bg: '#fee2e2', color: '#991b1b' },   // terminal en rojo (sin próxima acción)
  vencido:     { bg: '#fef3c7', color: '#92400e' },
  convertido:  { bg: '#dcfce7', color: '#14532d' },
  reemplazado: { bg: '#f1f5f9', color: '#94a3b8' },
}

export const LABELS_PRESUPUESTO = {
  borrador: 'Borrador',
  enviado: 'Enviado',
  aceptado: 'Aceptado',
  aprobado: 'Aprobado',
  rechazado: 'Rechazado',
  perdido: 'Perdido',
  vencido: 'Vencido',
  convertido: 'Convertido a NV',
  reemplazado: 'Reemplazado',
}

export default function EstadoBadgePresupuesto({ estado }) {
  const style = COLORES_PRESUPUESTO[estado] || { bg: '#f1f5f9', color: '#64748b' }
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.02em',
      textTransform: 'uppercase',
      background: style.bg,
      color: style.color,
    }}>
      {LABELS_PRESUPUESTO[estado] || estado}
    </span>
  )
}
